import { h } from 'preact';
import { TextFieldEntry } from '../entries/TextFieldEntry';

export class IdentityPropertiesProvider {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:Process';
  }

  getGroups(element) {
    const { lf, i18n } = { lf: this._lf, i18n: this._i18n };
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
    };

    return [
      {
        id: 'identity',
        label: i18n.identity || 'Identity',
        entries: [
          {
            id: 'processGuid',
            component: () => (
              <TextFieldEntry
                id="epx-process-guid"
                label="Process GUID"
                value={props.guid || ''}
                onChange={(val) => update('guid', val)}
              />
            ),
          },
          {
            id: 'processCode',
            component: () => (
              <TextFieldEntry
                id="epx-process-code"
                label={i18n.code || 'Code'}
                value={props.code || ''}
                onChange={(val) => update('code', val)}
              />
            ),
          },
          {
            id: 'processUrl',
            component: () => (
              <TextFieldEntry
                id="epx-process-url"
                label="URL"
                value={props.url || ''}
                onChange={(val) => update('url', val)}
              />
            ),
          },
        ],
      },
    ];
  }
}
